import React, {Component} from 'react';
import {connect} from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import * as A from '../store/lineageActions';

/**
 * Picks a DB connection from /manageDb/getDbConnection.
 * onChange(connectionId) — caller stores the id.
 */
class ConnectionPicker extends Component {
  componentDidMount() {
    this.props.fetchConnections();
  }

  render() {
    const {value, onChange, connections, label} = this.props;
    const pickerLabel = label || 'Database connection';
    if (!connections.length) {
      return (
        <FormControl fullWidth>
          <InputLabel>{pickerLabel}</InputLabel>
          <Select value="" disabled>
            <MenuItem value="">No connections available</MenuItem>
          </Select>
          <FormHelperText>Add connections in Manage DB first</FormHelperText>
        </FormControl>
      );
    }
    return (
      <FormControl fullWidth>
        <InputLabel>{pickerLabel}</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          inputProps={{'data-testid': 'connection-picker-select'}}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {connections.map((c) => (
            <MenuItem key={c.idconnectiondetail || c.id} value={c.idconnectiondetail || c.id}>
              {c.connection_name || c.name || c.idconnectiondetail || c.id}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

const mapStateToProps = (state) => ({connections: state.lineageReducer.connections});

export default connect(mapStateToProps, {fetchConnections: A.fetchConnections})(ConnectionPicker);
